import React from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import './main-influencer.scss';
import MobileFooter from '../../components/mobile/mobile-footer';
import { ZapOnlyGuard } from '../../components/guards/ZapOnlyGuard';
import { AccountAreaGuard } from '../../components/guards/AccountAreaGuard';
import { showsPhoneFooter } from '../../modules/influencer/routes';


export const MainInfluencer: React.FC = () => {
  const location = useLocation();

  const footerRoutes = new Set([
    "/influencer/dashboard",
    "/influencer/mycampaigns",
    "/influencer/zap",
    "/influencer/zap/automations",
    "/influencer/settings"
  ]);

  // The new campaign flow's Home / Branded Partnerships / My Campaigns too.
  const showFooter = footerRoutes.has(location.pathname) || showsPhoneFooter(location.pathname);
  return (
    <>
      {/* Foreign (US) influencers are restricted to the Zap-only flow; the guard
          redirects any non-Zap influencer route to the Zap hub. India users pass
          through unaffected. */}
      <AccountAreaGuard area="influencer">
        <ZapOnlyGuard>
          <Outlet />
        </ZapOnlyGuard>
      </AccountAreaGuard>
      {showFooter && <MobileFooter />}
    </>
  );
};
